<template>
  <ul>
    <li v-for="item in list" :key="item.id">{{item.listItem}}</li>
  </ul>
</template>

<script setup>
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String
})

const list = fieldFactory('list', props.popStoreId)

</script>

<style>

</style>